const LEGACY_KEY = "inputData";

// RW-60: returning visitors may still have contact personal data in localStorage["inputData"]
// from before this fix moved form state to sessionStorage. Remove it on app load so the privacy
// fix also remediates already-exposed data.
//
// Targets ONLY the inputData key — the i18next language key ("i18nextLng") and any other key are
// deliberately left untouched (language preference is not personal data). Idempotent and safe to
// call on every load, including when the key is absent or holds a corrupt value.
export function purgeLegacyInputData(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(LEGACY_KEY);
  } catch (error) {
    console.error(error);
  }
}
